import { useEffect } from "react";
import { useRouter } from "next/router";

interface Props {
  className?: string;
  style?: React.CSSProperties;
  clientId?: string;
  slotId: string;
  layout?: string;
  layoutKey?: string;
  format?: string;
  responsive?: string;
  pageLevelAds?: boolean;
  adTest?: string;
  children?: React.ReactNode;
  id?: string;
  key?: string;
}

export const CardAds: React.FC<Props> = ({
  className = "",
  style = { display: "block" },
  clientId = "ca-pub-9455978208365758",
  slotId,
  layout = "",
  layoutKey = "",
  format = "auto",
  responsive = "false",
  pageLevelAds = false,
  adTest,
  children,
  ...props
}) => {
  const router = useRouter();
  // === TEMPORARY NOT USED BY ===
  useEffect(() => {
    try {
      //@ts-ignore
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (err) {
      console.log(err);
    }
  }, []);

  return (
    //@ts-ignore
    <div
      className="card-ads"
      key={props?.key || router.asPath}
      id={props?.id || router.asPath}
    >
      <ins
        className={"adsbygoogle"}
        data-ad-client="ca-pub-9455978208365758"
        data-ad-slot={slotId}
        data-ad-format="auto"
        data-full-width-responsive="true"
        style={{ display: 'block' }}
      ></ins>

      {/* <ins
        className={`adsbygoogle ${className}`}
        style={style}
        data-ad-client={clientId}
        data-ad-slot={slotId}
        data-ad-layout={layout}
        data-ad-layout-key={layoutKey}
        data-ad-format={format}
        data-full-width-responsive={responsive}
        data-adtest={adTest}
        {...rest}
      >
        {children}
      </ins> */}
    </div>
  );
};
